<template>
  <div id="meta-app">
    <template v-if="loading">
      <div ref="splash" class="splashscreen">
        <img :src="$appInfo.logo">
      </div>
    </template>
    <template v-else>
      <AppHeader/>
      <div class="container">
        <router-view/>
      </div>
      <nav class="bottom-nav" v-if="$layout.menu == 'bottom-nav'">
        <router-link tag="button" to="/module/dm1">DM1</router-link>
        <router-link tag="button" to="/module/dm2">DM2</router-link>
      </nav>
      <SideDrawer v-if="drawerOn"/>
    </template>
    <Dialog :isOn="dialogOn" :data="dialogData"/>
    <Modal :isOn="modalOn" :component="modalComponent" :data="modalData"/>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer'
import AppHeader from '@/components/AppHeader'
import Dialog from '@/components/Dialog'
import Modal from '@/components/Modal'

import { isMobile, isSafari, isIOS } from 'mobile-device-detect'


export default {
  metaInfo () {
    return {
      title: this.$appInfo.title
    }
  },
  components: {
    SideDrawer,
    AppHeader,
    Dialog,
    Modal
  },
  data(){
    return {
      drawerOn: false,
      loading: true,
      dialogOn: false,
      dialogData: null,
      modalOn: false,
      modalData: null,
      modalComponent: null
    }
  },
  async created(){
    this.$eventBus.$on('toggleDrawer', () => {
      this.toggleDrawer()
    })

    console.log(this.$dialog)

    this.$eventBus.$on('alert-on', (data) => {
      this.dialogOn = true
      this.dialogData = data
    })

    this.$eventBus.$on('alert-off', () => {
      this.dialogOn = false
      this.dialogData = null
    })

    this.$eventBus.$on('modal-on', (data) => {
      console.log(data.component)
      this.modalOn = true
      this.modalData = data.data
      this.modalComponent = data.component
    })

    this.$eventBus.$on('modal-off', () => {
      this.modalOn = false
      this.modalData = null
      this.modalComponent = null
    })

    const authToken = localStorage.getItem('auth-token')
    if(authToken){
      this.$axios.post(`https://user.service.blackmoonlab.net/${this.$appInfo.name}/verify-jwt`, {
        token: authToken  
      })
      .then(response => {
        console.log(response.data)
        if(response.data === 'Invalid Token'){
          localStorage.setItem('auth-token', null)
          this.$router.push('/not-logged-in')
        }
        else {
          this.$sharedStore.set('user_id', response.data.idUser)
          this.$sharedStore.set('firstname', response.data.firstname)
          this.$sharedStore.set('lastname', response.data.lastname)
          this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + authToken;
          //axios.defaults.headers.common['Authorization'] = 'Bearer flflflflflflflflf';
        }
        this.$refs.splash.classList.add('splash')
        setTimeout(() => {
          this.loading = false
        }, 1500)
      })
    }
    else {
      setTimeout(() => {
        this.$refs.splash.classList.add('splash')
      }, 500)
      setTimeout(() => {
        this.loading = false
      }, 1500)
      this.$router.push('/not-logged-in')
    }

    this.$router.beforeEach((to, from, next) => {
      if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!this.$sharedStore.state.user_id) {
          next({
            path: '/not-logged-in',
            /* query: { redirect: to.fullPath } */
          })
        } else {
          next()
        }
      } else {
        next() // make sure to always call next()!
      }
    })

    setTimeout(async () => {
      if(isMobile && isIOS && localStorage.getItem('hasSeenAddToHomeScreen') != 'ok'){
        if(isSafari){
          const result = await this.$dialog.display({
            message: `<p class="message-title">Installez moi comme une app normale</p><ul class="dialog-message-list"><li>Appuyez l'icone <img src="https://static.makeuseof.com/wp-content/uploads/2018/06/ios_share_icon_button_iphone.jpg" class="in-message-icon"></li><li>Appuyez sur le bouton "Sur l'écran d'accueil"</li><li>Appuyer sur le bouton "Ajouter"</li></ul>`,
            choices: [
              {
                label: 'OK',
                data: 'ok'
              }
            ]
          })
          if(result == 'ok'){
            localStorage.setItem('hasSeenAddToHomeScreen', 'ok')
          }
        }
        else {
          const result = await this.$dialog.display({
            message: `<p class="message-title">Installez moi comme une app normale</p><p>Tout d'abord, ouvrez moi avec Safari</p>`,
            choices: [
              {
                label: 'OK',
                data: 'ok'
              }
            ]
          })
          if(result == 'ok'){
            localStorage.setItem('hasSeenAddToHomeScreen', 'ok')
          }
        }
      }
    }, 3000)

  },
  methods: {
    toggleDrawer(){
      this.drawerOn = !this.drawerOn
    }
  }
}
</script>

<style lang="scss" scoped>
  #meta-app {
    display: flex;
    height: 100vh;
    //height: calc(var(--vh, 1vh) * 100);
    height: vh(100);
    width: 100vw;
    flex-direction: column;

    .container {
      height: vh(78);
    }

    .bottom-nav {
      background-color: $secondary;
      height: 8vh;
      height: vh(7);
    }

    .splash {
      animation-name: fade;
      animation-delay: 1s;
      animation-duration: 0.5s;  
    }

    .splashscreen {
      height: vh(100);
      width: 100vw;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 30%;
        object-fit: contain;
      }

      @keyframes fade {
        from {
          opacity: 100;
        }
        to {
          opacity: 0;
        }
      }
    }
  }
</style>
